var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPage = function SvgPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#D0D5DD",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 4A3.25 3.25 0 0 1 4 .75h16c.121 0 .238.048.323.134l10.793 10.793a.457.457 0 0 1 .134.323v24A3.25 3.25 0 0 1 28 39.25H4A3.25 3.25 0 0 1 .75 36V4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 .5V8a4 4 0 0 0 4 4h7.5"
  }))));
};
export { SvgPage as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCAzMiA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJQYWdlIj4NCjxwYXRoIGlkPSJQYWdlIGJhY2tncm91bmQiIGQ9Ik0wLjc1IDRDMC43NSAyLjIwNTA4IDIuMjA1MDggMC43NSA0IDAuNzVIMjBDMjAuMTIxMiAwLjc1IDIwLjIzNzUgMC43OTgxNTkgMjAuMzIzMiAwLjg4Mzg4NUwzMS4xMTYxIDExLjY3NjhDMzEuMjAxOCAxMS43NjI1IDMxLjI1IDExLjg3ODggMzEuMjUgMTJWMzZDMzEuMjUgMzcuNzk0OSAyOS43OTQ5IDM5LjI1IDI4IDM5LjI1SDRDMi4yMDUwNyAzOS4yNSAwLjc1IDM3Ljc5NDkgMC43NSAzNlY0WiIgZmlsbD0id2hpdGUiIHN0cm9rZT0iI0QwRDVERCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4NCjxwYXRoIGlkPSJFYXJtYXJrIiBkPSJNMjAgMC41VjhDMjAgMTAuMjA5MSAyMS43OTA5IDEyIDI0IDEySDMxLjUiIHN0cm9rZT0iI0QwRDVERCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4NCjwvZz4NCjwvc3ZnPg0K";